import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const agentOutputCss = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-s')};
  padding: ${m('--spacing-m')} 0;
  white-space: pre-wrap;
  width: 100%;
`;

export const agentOutputContentCss = css`
  font-size: ${m('--p3-mobile-font-size')};
  line-height: 140%;

  & p {
    margin-bottom: ${m('--spacing-m')};

    &:last-child {
      margin-bottom: 0;
    }
  }

  & ul,
  & ol {
    margin-bottom: ${m('--spacing-m')};
    padding-left: ${m('--spacing-l')};

    &:last-child {
      margin-bottom: 0;
    }
  }

  & b,
  & strong {
    font-weight: 600;
  }

  & a {
    color: ${m('--hyperlink-color')};
    text-decoration: underline;

    &:hover {
      color: ${m('--hyperlink-hover-color')};
    }
  }
`;
